export default __webpack_public_path__ + "static/sustain-wrap2x-3ba1b3516fe2266403111852aa228f11.png";